import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2 9C2 9.55208 1.55208 10 1 10C0.447916 10 0 9.55208 0 9C0 8.44792 0.447916 8 1 8C1.55208 8 2 8.44792 2 9Z"
          fill="#7A8499"
        />
        <path
          d="M2 5C2 5.55208 1.55208 6 1 6C0.447916 6 0 5.55208 0 5C0 4.44792 0.447916 4 1 4C1.55208 4 2 4.44792 2 5Z"
          fill="#7A8499"
        />
        <path
          d="M2 1C2 1.55208 1.55208 2 1 2C0.447916 2 0 1.55208 0 1C0 0.447916 0.447916 0 1 0C1.55208 0 2 0.447916 2 1Z"
          fill="#7A8499"
        />
        <path
          d="M5.33301 9C5.33301 9.55208 4.88509 10 4.33301 10C3.78092 10 3.33301 9.55208 3.33301 9C3.33301 8.44792 3.78092 8 4.33301 8C4.88509 8 5.33301 8.44792 5.33301 9Z"
          fill="#7A8499"
        />
        <path
          d="M5.33301 5C5.33301 5.55208 4.88509 6 4.33301 6C3.78092 6 3.33301 5.55208 3.33301 5C3.33301 4.44792 3.78092 4 4.33301 4C4.88509 4 5.33301 4.44792 5.33301 5Z"
          fill="#7A8499"
        />
        <path
          d="M5.33301 1C5.33301 1.55208 4.88509 2 4.33301 2C3.78092 2 3.33301 1.55208 3.33301 1C3.33301 0.447916 3.78092 0 4.33301 0C4.88509 0 5.33301 0.447916 5.33301 1Z"
          fill="#7A8499"
        />
      </svg>
    </>
  );
};
